import { cn } from '@natu/utils/cn';

import {
  type BlokItem,
  type Grid,
  type SBProps,
  type Size,
  type Spacing,
  DynamicRender,
  resolveStoryblokStyles,
  sbEditable,
} from '../../../../utils';

interface SBTeaserProps {
  firstColumn?: BlokItem[];
  secondColumn?: BlokItem[];
  reversed?: boolean;
  reversedTablet?: boolean;
  reversedDesktop?: boolean;
  gridMobile?: Grid;
  gridTablet?: Grid;
  gridDesktop?: Grid;
  gapMobile?: Spacing;
  gapTablet?: Spacing;
  gapDesktop?: Spacing;
  containerSize?: Size;
  mtMobile?: Spacing;
  mtTablet?: Spacing;
  mtDesktop?: Spacing;
  mbMobile?: Spacing;
  mbTablet?: Spacing;
  mbDesktop?: Spacing;
}

export const SBTeaser = ({ blok }: SBProps<SBTeaserProps>) => {
  const {
    firstColumn,
    secondColumn,
    reversed,
    reversedTablet,
    reversedDesktop,
    gridMobile,
    gridTablet,
    gridDesktop,
    gapMobile,
    gapTablet,
    gapDesktop,
    containerSize,
    mbMobile,
    mbTablet,
    mbDesktop,
    mtMobile,
    mtTablet,
    mtDesktop,
  } = blok;

  const classNames = {
    wrapper: resolveStoryblokStyles({
      gridMobile,
      gridTablet,
      gridDesktop,
      gap: gapMobile,
      gapTablet,
      gapDesktop,
      size: containerSize,
      mt: mtMobile,
      mtTablet,
      mtDesktop,
      mb: mbMobile,
      mbTablet,
      mbDesktop,
      className: 'grid items-stretch',
    }),
    column: 'grid grid-cols-1',
    reversed: cn(
      reversed && 'order-[-1]',
      reversedTablet && 'md:order-[-1]',
      reversedDesktop && 'lg:order-[-1]',
    ),
  };

  return (
    <div className={classNames.wrapper} {...sbEditable(blok)}>
      <div className={classNames.column}>
        <DynamicRender data={firstColumn} />
      </div>
      <div className={classNames.reversed}>
        <DynamicRender data={secondColumn} />
      </div>
    </div>
  );
};
